import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AjaxService } from '../../../core/services/ajax.service';

@Injectable()
export class ComponentService {
    baseUrl: string = 'Component.svc';

    constructor(private http: Http, private _ajaxService: AjaxService) {
    }

    get(pageName: string){
    	return this._ajaxService.GET(this.baseUrl + "/getComponentDetail/" + (pageName == '' ? 'login' : pageName));
    }
    
    getVersionDetails(){
        return this._ajaxService.GET(this.baseUrl + "/getVersionDetails");
    }

}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/services/component.service.ts